module.exports = __webpack_public_path__ + "img/team.759723da.jpg";